import * as React from 'react';

const SvgSimilar = (props) => /* @__PURE__ */ React.createElement("svg", { "data-fabric-icon-v2": "navigational-24", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 15.0002, cy: 15.0002, r: 6.0002, fill: "#9C9C9C" }), /* @__PURE__ */ React.createElement("circle", { cx: 8.99971, cy: 9.0002, r: 6.0002, fill: "currentColor" }));

export { SvgSimilar as default };
//# sourceMappingURL=similar.svg.js.map
